// @ts-nocheck
import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import Img, { ImagePresentationProps } from "@store/MobiusOverrides/Img/Img";
import { boxGlassStyles } from "@store/Themes/common/mixins/box";
import useExpandProps, { ExpandStyles } from "@toolkit/Framework/Common/Hooks/useExpandProps";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { spacingStyles } from "@toolkit/Themes/common/mixins";
import parse from "html-react-parser";
import React, { FC } from "react";
import { css } from "styled-components";

export interface AccountApplicationSideContentPresentationProps
    extends ExpandStyles<AccountApplicationSideContentStyles> {}

export interface AccountApplicationSideContentProps extends AccountApplicationSideContentPresentationProps {
    body?: string;
    title?: string;
    titleImageSrc?: string;
}

export interface AccountApplicationSideContentStyles {
    bodyWrapper?: InjectableCss;
    title?: TypographyPresentationProps;
    titleImage?: ImagePresentationProps;
    wrapper?: InjectableCss;
}

export const accountApplicationSideContentStyles: AccountApplicationSideContentStyles = {
    wrapper: {
        css: css`
            ${boxGlassStyles()}
            width: 100%;
            max-width: ${pxToRem(610)};
            padding: ${pxToRem(24)};
        `,
    },
    titleImage: {
        css: css`
            display: block;
            flex-shrink: 0;
        `,
    },
    title: {
        variant: "h3",
        forwardAs: "h2",
        css: css`
            ${spacingStyles(null, pxToRem(16))}
            display: flex;
            align-items: center;
            gap: ${pxToRem(16)};
        `,
    },
};

const AccountApplicationSideContent: FC<AccountApplicationSideContentProps> = ({
    body,
    extendedStyles,
    overridedStyles,
    title,
    titleImageSrc,
}) => {
    const styles = useExpandProps(accountApplicationSideContentStyles, extendedStyles, overridedStyles);

    if (!title && !body) {
        return null;
    }

    return (
        <StyledWrapper {...styles.wrapper} data-test-selector="accountApplication_SideContent">
            {title && (
                <Typography {...styles.title}>
                    {titleImageSrc && <Img {...styles.titleImage} altText="" src={titleImageSrc} />}
                    {title}
                </Typography>
            )}
            {body && <StyledWrapper {...styles.bodyWrapper}>{parse(body, parserOptions)}</StyledWrapper>}
        </StyledWrapper>
    );
};

export default AccountApplicationSideContent;
